var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export default function intervalUntil({ callback, stopCondition, timeout, retries }) {
    return __awaiter(this, void 0, void 0, function* () {
        let tryCount = retries !== null && retries !== void 0 ? retries : -1;
        return new Promise(resolve => {
            const interval = setInterval(() => {
                const stop = stopCondition();
                if (stop || tryCount-- === 0) {
                    clearInterval(interval);
                    return resolve(stop);
                }
                callback();
            }, timeout);
        });
    });
}
//# sourceMappingURL=intervalUntil.js.map